import React from "react";

function UseLocalStorage(itemName , initialValue){
    const [item,setItem] = React.useState(initialValue);  
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);

    React.useEffect(()=>{

      setTimeout(()=>{
        try{
          const localStorageItem = localStorage.getItem(itemName);
        
          let parsedItem;
  
          if(!localStorageItem){
            localStorage.setItem(itemName,JSON.stringify(initialValue));
            parsedItem = initialValue;
          }else{
            parsedItem = JSON.parse(localStorageItem);
            setItem(parsedItem);
          }
          setLoading(false);
        }catch(error){
          setError(true);
          setLoading(false); 
        }
      },2000)
    },[]);
  
    function saveItem (newItem) {
    localStorage.setItem('TODOS_V1', JSON.stringify(newItem));
    setItem(newItem);
  }
    
    return {
      item,
      saveItem,
      loading,
      error,
    };
}

export { UseLocalStorage }

//localStorage.removeItem('TODOS_V1')
// const defaultTodos = [
//   {text:'tarea UNO',completed: false},
//   {text:'tarea DOS',completed: true},
//   {text:'tarea TRES',completed: false}
// ] 
// localStorage.setItem('TODOS_V1',JSON.stringify(defaultTodos));